import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {Divider, makeStyles} from '@material-ui/core'
import useLangEn from 'hooks/useLangEn'
import HealthCenterReportStyle from 'pages/HealthCenter/Report/Style'
import WrapElement from 'pages/HealthCenter/Report/Elements/WrapElement'
import AIDementiaPredictionGuide from './AIDementiaPredictionGuide'

const useStyles = makeStyles(HealthCenterReportStyle)

export interface AIDementiaPredictionProps {
  mciResultImage: string
  mciProbability: number
  name: string
  footer: string
}

const AIDementiaPrediction = ({
  mciResultImage,
  mciProbability,
  name,
  footer,
}: AIDementiaPredictionProps) => {
  const {t} = useTranslation()
  const classes = useStyles()
  const isEm = useLangEn()

  const data = useMemo(() => {
    return [
      {
        index: 1,
        stepText: `${t('IStage1')} (~50%)`,
        title: t('IAIDementiaPredictionLv1Title1'),
        content: [
          t('IAIDementiaPredictionLv1Tex1'),
          t('IAIDementiaPredictionLv1Tex2'),
        ],
        color: '#15A87A',
        isActive: mciProbability < 50,
      },
      {
        index: 2,
        stepText: `${t('IStage2')} (50~60%)`,
        title: t('IAIDementiaPredictionLv2Title1'),
        content: [
          t('IAIDementiaPredictionLv2Tex1'),
          t('IAIDementiaPredictionLv2Tex2'),
        ],
        color: '#63C54B',
        isActive: mciProbability >= 50 && mciProbability < 60,
      },
      {
        index: 3,
        stepText: `${t('IStage3')} (60~70%)`,
        title: t('IAIDementiaPredictionLv3Title1'),
        content: [
          t('IAIDementiaPredictionLv3Tex1'),
          t('IAIDementiaPredictionLv3Tex2'),
        ],
        color: '#EBC600',
        isActive: mciProbability >= 60 && mciProbability < 70,
      },
      {
        index: 4,
        stepText: `${t('IStage4')}  (70~85%)`,
        title: t('IAIDementiaPredictionLv4Title1'),
        content: [
          t('IAIDementiaPredictionLv4Tex1'),
          t('IAIDementiaPredictionLv4Tex2'),
        ],
        color: '#E3A037',
        isActive: mciProbability >= 70 && mciProbability < 85,
      },
      {
        index: 5,
        stepText: `${t('IStage5')}  (85%~)`,
        title: t('IAIDementiaPredictionLv5Title1'),
        content: [
          t('IAIDementiaPredictionLv5Tex1'),
          t('IAIDementiaPredictionLv5Tex2'),
        ],
        color: '#D14126',
        isActive: mciProbability >= 85,
      },
    ]
  }, [mciProbability, isEm])
  return (
    <div className={classes.brainBasic}>
      <WrapElement number={1} text={t('IAIDementiaPrediction')}>
        <div className={classes.contentCard}>
          <img
            className={classes.mciResultImage}
            src={mciResultImage}
            alt='mci'
          />
        </div>
        <div className={classes.mciResultDes}>
          <div className={classes.mciResultDesTitle}>
            {t('IMciResultDesTitle', {
              name,
              step: data.find((item) => item.isActive)?.index || 1,
            })}
          </div>
          <div className={classes.mciResultDesContent}>
            <div className={classes.mciResultDesContentList}>
              <div className={classes.mciResultDesContentText}>
                <span>1</span>
                {t('IMciResultDesContentText1')}
              </div>
              <div className={classes.mciResultDesContentText}>
                <span>2</span>
                {t('IMciResultDesContentText2')}
              </div>
            </div>
            <div className={classes.mciResultDesContentText}>
              {t('IMciResultDesContentText3')}
            </div>
          </div>
          <div className={classes.AIDementiaPredictionDetail}>
            {data.map((content) => (
              <AIDementiaPredictionGuide
                key={content.index}
                stepText={content.stepText}
                color={content.color}
                title={content.title}
                content={content.content}
                isActive={content.isActive}
              />
            ))}
          </div>
          <div className={classes.mciResultNote}>
            <div className={classes.mciResultNoteElm}>
              <span>*</span>
              {t('IMciResultNote1')}
            </div>
            <div className={classes.mciResultNoteElm}>
              <span>*</span>
              {t('IMciResultNote2')}
            </div>
            <div className={classes.mciResultNoteElm}>
              <span>*</span>
              {t('IMciResultNote3')}
            </div>
            <div className={classes.mciResultNoteElm}>
              <span>*</span>
              {footer.replace(/\*/g, '')}
            </div>
          </div>
        </div>
      </WrapElement>
      {/* <Divider style={{marginLeft: 10, marginRight: 10, marginBottom: 10}} /> */}
      {/* <div className={classes.footer}>{footer}</div> */}
    </div>
  )
}

export default AIDementiaPrediction
